import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listMerch } from "../Redux/Actions/merchActions";
import Loading from "../components/LoadingError/Loading";
import Message from "../components/LoadingError/Error";
import Header from "../components/Header";
import Footer from "../components/Footer";
// import { Link } from "react-router-dom";

const MerchScreen = ({ history }) => {
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [priceSort, setPriceSort] = useState("default");
  const dispatch = useDispatch();

  const merchList = useSelector((state) => state.merchList || {});
  const { loading, error, merch = [] } = merchList;

  const categories = merch.length > 0 
    ? ["all", ...new Set(merch.map(item => item.category))]
    : ["all"];

  useEffect(() => {
    dispatch(listMerch());
  }, [dispatch]);

  const filteredMerch = merch.filter((item) =>
    categoryFilter === "all"
      ? true
      : item.category?.toLowerCase() === categoryFilter.toLowerCase()
  );

  const sortedMerch = [...filteredMerch].sort((a, b) => {
    if (priceSort === "low-to-high") return parseFloat(a.price) - parseFloat(b.price);
    if (priceSort === "high-to-low") return parseFloat(b.price) - parseFloat(a.price);
    return 0;
  });

  const handleBuyNowClick = (id) => {
    history.push(`/merchandise/${id}`);
  };

  return (
    <>
      <Header isHomePage={false} />
      <div className="merchscreen-container">
        <h1 className="merchscreen-title">Merchandise</h1>

        <div className="merchscreen-filters">
          <div>
            <select
              className="merchscreen-select"
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
            >
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category === "all" ? "All Items" : category}
                </option>
              ))}
            </select>
          </div>

          <div>
            <select
              className="merchscreen-select"
              value={priceSort}
              onChange={(e) => setPriceSort(e.target.value)}
            >
              <option value="default">Default</option>
              <option value="low-to-high">Price: Low to High</option>
              <option value="high-to-low">Price: High to Low</option>
            </select>
          </div>
        </div>

        {loading ? (
          <Loading />
        ) : error ? (
          <Message variant="danger">{error}</Message>
        ) : sortedMerch.length === 0 ? (
          <div className="merchscreen-empty">No merchandise found</div>
        ) : (
          <div className="merchscreen-grid">
            {sortedMerch.map((item) => (
              <div key={item._id} className="merchscreen-card">
                <div className="merchscreen-image-container">
                  <img src={item.image} alt={item.name} className="merchscreen-image" />
                  {item.countInStock <= 0 && (
                    <div className="merchscreen-outofstock">
                      <span className="merchscreen-outofstock-label">
                        Out of Stock
                      </span>
                    </div>
                  )}
                  {item.countInStock > 0 && item.countInStock <= 5 && (
                    <div className="merchscreen-lowstock">
                      <span className="merchscreen-lowstock-label">
                        Low Stock
                      </span>
                    </div>
                  )}
                </div>

                <div className="merchscreen-card-content">
                  <h3 className="merchscreen-card-title">{item.name}</h3>
                  <p className="merchscreen-card-price">Ksh {item.price}</p>
                  <button
                    className={`merchscreen-buybtn ${
                      item.countInStock <= 0 ? "merchscreen-buybtn-disabled" : ""
                    }`}
                    disabled={item.countInStock <= 0}
                    onClick={() => handleBuyNowClick(item._id)}
                  >
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default MerchScreen;